var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-accounts"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("Yahoo!JAPAN ビジネスID 一覧")])])],1),_c('el-row',[_c('el-col',[_c('BussinessAccountList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }